import { getData, postData } from "@/request/api";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useRequestComplaints = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: any) => {
      const response = await postData("complaints/request", data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["complaints"] });
    },
  });
};

export const useGetComplaintByTicket = (ticketNumber: string | null) => {
  return useQuery({
    queryKey: ["complaint-track", ticketNumber],
    queryFn: async () => {
      const response = await getData(
        `complaints/track?ticket_number=${ticketNumber}`,
      );
      return response.data;
    },
    enabled: !!ticketNumber,
    staleTime: 1000 * 30,
  });
};
